import { useMeQuery } from '@platform/state/api';
import type { Capability } from '@platform/core/types';

/** Чи має поточний користувач можливість `cap` у воркспейсі (UIUX patterns/scopes-and-permissions: недоступні дії ховаються чи вимикаються). */
export function useCapability(ws: string, cap: Capability): boolean {
  const { data: me } = useMeQuery();
  return Boolean(me?.workspaces.find((w) => w.id === ws)?.myCapabilities.includes(cap));
}
